import { graphql } from "@/api/graphql/codegen";

export const UpdateParticipantMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateParticipant($participantInput: UpdateParticipantInput!) {
    updateParticipant(updateParticipantInput: $participantInput) {
      id
    }
  }
`);
